import React from 'react';
import { Link } from 'react-router-dom';
import s from './Unauthorised.module.scss';
// import img from '../../assets/Unauthorised401.svg';
import { Button } from "reactstrap"

const Unauthorised = () => (
  <div className={s.unauthorised}>
    <div className={s.container}>
      {/* <img src={img} alt="unauthorised" /> */}
      <h1>
        Error 401
      </h1>
      <h5 className={s.subHeading}>
        You are not authorised to view this page
      </h5>
      <Link to={`/`}>
        <Button className={s.btnChange}>
          Return Home
        </Button>
      </Link>
    </div>
  </div>
);
export default Unauthorised;
